<template>
  <el-card>
    <Basic />
    <ROI />

  </el-card>
</template>

<script>
import Basic from '@/views/config/data-stat/components/basic.vue'
import ROI from '@/views/config/data-stat/components/roi.vue'
export default {
  name: 'Index',
  components: { Basic, ROI }
}
</script>

<style scoped>

</style>
